import React from "react";
import { SUPPORT_EMAIL } from "@/components/auth/authCopy";

const baseUrl = import.meta.env.VITE_LANDING_URL;

const legalLinks = [
    { href: `${baseUrl}/privacy`, label: "Privacy Policy" },
    { href: `${baseUrl}/terms`, label: "Terms" },
];

/**
 * The auth surface's footer — quiet and low, replacing the full marketing
 * footer the glass-card shell used to carry.
 *
 * Desktop: a single legal line under the card. Below 900px it becomes the
 * prototype's pinned strip (aits-2.0 `.auth-mobile-footer`) and picks up the
 * support line, because the in-card `.auth-help` block is desktop-only.
 */
export default function Footer() {
    return (
        <footer className="auth-footer">
            <p className="auth-footer__support">
                Stuck? Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </p>
            <div className="auth-footer__legal">
                <span>© AI Trust Signals™ 2026</span>
                {legalLinks.map(({ href, label }) => (
                    <a key={href} href={href} target="_blank" rel="noopener noreferrer">
                        {label}
                    </a>
                ))}
            </div>
        </footer>
    );
}
